export const MODAL_VISIBILITY = "MODAL_VISIBILITY";
export const AGENT_MODAL_VISIBILITY = "AGENT_MODAL_VISIBILITY";
export const DATE_MODAL_VISIBILITY = "DATE_MODAL_VISIBILITY";
export const TRANSFER_MODAL_VISIBILITY = "TRANSFER_MODAL_VISIBILITY";